import { S as SocialLoginResponseStatus } from './SocialLoginResponseStatus-BP1cpX8W.js';
import { g as getDefaultExportFromCjs } from './_commonjsHelpers-B85MJLTf.js';
import require$$0 from 'crypto';

var cryptoRandomString$1;
var hasRequiredCryptoRandomString;
function requireCryptoRandomString() {
    if (hasRequiredCryptoRandomString) return cryptoRandomString$1;
    hasRequiredCryptoRandomString = 1;
    var crypto = require$$0;
    var urlSafeCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~'.split('');
    var numericCharacters = '0123456789'.split('');
    var distinguishableCharacters = 'CDEHKMPRTUWXY012458'.split('');
    var generateForCustomCharacters = function(length, characters) {
        // Generating entropy is faster than complex math operations, so we use the simplest way
        var characterCount = characters.length;
        var maxValidSelector = Math.floor(0x10000 / characterCount) * characterCount - 1; // Using values above this will ruin distribution when using modular division
        var entropyLength = 2 * Math.ceil(1.1 * length); // Generating a bit more than required so chances we need more than one pass will be really low
        var string = '';
        var stringLength = 0;
        while(stringLength < length){
            var entropy = crypto.randomBytes(entropyLength);
            var entropyPosition = 0;
            while(entropyPosition < entropyLength && stringLength < length){
                var entropyValue = entropy.readUInt16LE(entropyPosition);
                entropyPosition += 2;
                if (entropyValue > maxValidSelector) {
                    continue;
                }
                string += characters[entropyValue % characterCount];
                stringLength++;
            }
        }
        return string;
    };
    var allowedTypes = [
        undefined,
        'hex',
        'base64',
        'url-safe',
        'numeric',
        'distinguishable'
    ];
    cryptoRandomString$1 = function(param) {
        var length = param.length, type = param.type, characters = param.characters;
        if (!(length >= 0 && Number.isFinite(length))) {
            throw new TypeError('Expected a `length` to be a non-negative finite number');
        }
        if (type !== undefined && characters !== undefined) {
            throw new TypeError('Expected either `type` or `characters`');
        }
        if (characters !== undefined && typeof characters !== 'string') {
            throw new TypeError('Expected `characters` to be string');
        }
        if (!allowedTypes.includes(type)) {
            throw new TypeError("Unknown type: " + type);
        }
        if (type === undefined && characters === undefined) {
            type = 'hex';
        }
        if (type === 'hex' || type === undefined && characters === undefined) {
            return crypto.randomBytes(Math.ceil(length * 0.5)).toString('hex').slice(0, length); // Need 0.5 byte entropy per character
        }
        if (type === 'base64') {
            return crypto.randomBytes(Math.ceil(length * 0.75)).toString('base64').slice(0, length); // Need 0.75 byte of entropy per character
        }
        if (type === 'url-safe') {
            return generateForCustomCharacters(length, urlSafeCharacters);
        }
        if (type === 'numeric') {
            return generateForCustomCharacters(length, numericCharacters);
        }
        if (type === 'distinguishable') {
            return generateForCustomCharacters(length, distinguishableCharacters);
        }
        if (characters.length === 0) {
            throw new TypeError('Expected `characters` string length to be greater than or equal to 1');
        }
        if (characters.length > 0x10000) {
            throw new TypeError('Expected `characters` string length to be less or equal to 65536');
        }
        return generateForCustomCharacters(length, characters.split(''));
    };
    return cryptoRandomString$1;
}

var cryptoRandomStringExports = requireCryptoRandomString();
var cryptoRandomString = /*@__PURE__*/getDefaultExportFromCjs(cryptoRandomStringExports);

var openLinePopup = function(config, state) {
    var height = 600;
    var width = 400;
    var top = window.innerHeight / 2 - height / 2;
    var left = window.innerWidth / 2 - width / 2;
    window.name = 'wwwagodacom';
    var lineAuthUrl = 'https://access.line.me/oauth2/v2.1/authorize';
    var popupUrl = new URL(lineAuthUrl);
    popupUrl.searchParams.append('response_type', 'code');
    popupUrl.searchParams.append('client_id', config.clientId);
    popupUrl.searchParams.append('scope', !!config.scope ? config.scope : '');
    popupUrl.searchParams.append('state', state);
    popupUrl.searchParams.append('redirect_uri', config.redirectUri);
    popupUrl.searchParams.append('bot_prompt', 'normal');
    if (config.appId === 'dictator' || config.appId === 'dspa') {
        popupUrl.searchParams.append('initial_amr_display', 'lineqr');
    }
    if (config.appId === 'androidAgoda' || config.appId === 'iosAgoda') {
        popupUrl.searchParams.append('initial_amr_display', 'lineqr');
        popupUrl.searchParams.append('switch_amr', 'false');
        popupUrl.searchParams.append('disable_auto_login', 'true');
        popupUrl.searchParams.append('disable_ios_auto_login', 'true');
    }
    return window.open(popupUrl.toString(), '_blank', "height=" + height + ",width=" + width + ",menubar=0,status=0,top=" + top + ",left=" + left);
};
var LineSdkLogin = function(config) {
    return new Promise(function(resolve) {
        var cleanup = function cleanup() {
            if (!!lineWindow && !lineWindow.closed) {
                try {
                    lineWindow.close();
                } catch (e) {
                    console.error('Failed to close popup window:', e);
                }
            }
            if (windowWatcher) {
                window.clearInterval(windowWatcher);
            }
            // Close the channel after a delay to ensure message processing
            setTimeout(function() {
                try {
                    channel.close();
                } catch (e) {
                    console.error('Failed to close BroadcastChannel:', e);
                }
            }, 1000);
        };
        var state = cryptoRandomString({
            length: 10,
            type: 'distinguishable'
        });
        var time = Date.now();
        var channel = new BroadcastChannel('line_login_channel');
        var isResolved = false;
        // Set up BroadcastChannel listener - this is the only message handling mechanism
        channel.onmessage = function(event) {
            var _event_data = event.data, code = _event_data.code, source = _event_data.source;
            if (source === 'lineCallback' && !isResolved) {
                isResolved = true;
                cleanup();
                if (code && code !== 'undefined' && code !== 'null') {
                    return resolve({
                        code: code,
                        status: SocialLoginResponseStatus.Success
                    });
                } else {
                    return resolve({
                        status: SocialLoginResponseStatus.Error,
                        error: 'nocode'
                    });
                }
            }
        };
        var lineWindow = openLinePopup(config, state);
        // Window watcher to detect if popup is closed without successful login
        var windowWatcher = 0;
        try {
            windowWatcher = window.setInterval(function() {
                if (!lineWindow || lineWindow.closed) {
                    if (!isResolved) {
                        isResolved = true;
                        cleanup();
                        var closeTime = Date.now();
                        return resolve({
                            status: SocialLoginResponseStatus.Error,
                            error: "window_closed " + (closeTime - time)
                        });
                    }
                }
            }, 10000);
        } catch (error) {
            if (!isResolved) {
                isResolved = true;
                cleanup();
                return resolve({
                    status: SocialLoginResponseStatus.Error,
                    error: "" + error
                });
            }
        }
    });
};

export { LineSdkLogin as L };
